import { useEffect } from 'react';
import CommonHeader from '../Components/Headers/CommonHeader';
import SharedButton from '../global/Button/Button';
import { useNavigate } from 'react-router-dom';

function ThankYouPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const _linkedin_partner_id = '8934697';
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);

    (function (l) {
      if (!l) {
        window.lintrk = function (a, b) {
          window.lintrk.q.push([a, b]);
        };
        window.lintrk.q = [];
      }
      const s = document.getElementsByTagName('script')[0];
      const b = document.createElement('script');
      b.type = 'text/javascript';
      b.async = true;
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      s.parentNode?.insertBefore(b, s);
    })(window.lintrk);

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://snap.licdn.com/li.lms-analytics/insight.min.js"]',
      );
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div>
      <CommonHeader />
      <div className="notFoundPage" style={{ height: '60vh' }}>
        <h2>Thank you for booking a demo</h2>
        <p>We&lsquo;ll be in touch soon!</p>
        <SharedButton
          id="brochure"
          size="xs"
          onClick={e => {
            e.preventDefault();
            navigate('/brochure');
          }}
          type="button"
          className="btn-gradient-pink mx-0 mb-2 px-4"
          style={{
            height: '40px',
            fontSize: '15px',
            textAlign: 'center',
            display: 'inline-block',
          }}
        >
          Learn more about DISGENET
        </SharedButton>
      </div>
      {/* LinkedIn Insight Tag noscript fallback */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=8934697&fmt=gif"
        />
      </noscript>
    </div>
  );
}

export default ThankYouPage;
